"use strict";

(function () {
  const init = async () => {
    try {
      document.documentElement.classList.remove("no-js");

      // Make sure scroll restoration is enabled
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "auto";
      }

      document.fonts.ready.then(() => {
        requestAnimationFrame(() => {
          document.body.classList.remove("preload");
        });
      });
    } catch (error) {
      console.error("Initialization error:", error);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
